const slider =  {
    hero: () => {
        jQuery('.js-hero-slider').slick({
            infinite: true,
            arrows: false,
            dots: true,
            slidesToShow: 1,
        });

        if( jQuery('.js-hero-slider .slick-active video').lenght ) {
            jQuery('.js-hero-slider .slick-active video')[0].play();  
        }

        jQuery('.js-hero-slider').on('afterChange', function(slick, currentSlide){

            if($( ".js-hero-slider video" ).lenght) {
                $( ".js-hero-slider video" ).each(function() {
                    $( this )[0].pause();  
                });
            }

            if(jQuery('.slick-active video').lenght) {
                jQuery('.slick-active video')[0].play();  
            }
          
        });
    }, 
    tiktok: () => {
        jQuery('.js-tiktok-slider').slick({
            infinite: false,
            arrows: false,
            dots: false,
            slidesToShow: 4,
        });
    } ,
    cards: () => {
        jQuery( ".section-slider-cards" ).each(function() {
            $( this ).find('.js-slider-cards').slick({
                infinite: true,
                arrows: true,
                dots: false,
                slidesToShow: 4,
                prevArrow:  jQuery(this).find('.js-arrow-left'),
                nextArrow:  jQuery(this).find('.js-arrow-right'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3, 
                            infinite: false,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2.1, 
                            infinite: false,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.1, 
                            infinite: false,
                            arrows: false
                        }
                    },
                ]
            });
        });
    },
}